/*
GENERATED by bin/tune-populations.ts — do not edit. Rerun it after changing
star-system generation or HI (star-populations.test.ts fails until you do).

5000 corpus stars per spectral cell, scored with the real rules. A cell's
rate is the fraction whose best planet has HI <= 2.
*/

/** What counts as interesting: a planet with HI at or below this. */
export const INTERESTING_MAX_HI = 2

/** Corpus size per cell. */
export const CORPUS_PER_CELL = 5000

/** The HI rules these rates were measured against — see hiFingerprint. */
export const HI_FINGERPRINT = '82da5176'

/** Fraction of each cell's systems that are interesting. */
export const PASS_RATE: Readonly<Record<string, number>> = {
  O0: 0,
  O1: 0,
  O2: 0,
  O3: 0,
  O4: 0,
  O5: 0,
  O6: 0,
  O7: 0,
  O8: 0,
  O9: 0,
  B0: 0.1186,
  B1: 0.147,
  B2: 0.1744,
  B3: 0.1778,
  B4: 0.189,
  B5: 0.1794,
  B6: 0.1766,
  B7: 0.192,
  B8: 0.178,
  B9: 0.1872,
  A0: 0.155,
  A1: 0.1434,
  A2: 0.1364,
  A3: 0.1212,
  A4: 0.1154,
  A5: 0.1032,
  A6: 0.1078,
  A7: 0.0962,
  A8: 0.0936,
  A9: 0.0838,
  F0: 0.141,
  F1: 0.1136,
  F2: 0.1216,
  F3: 0.1272,
  F4: 0.1266,
  F5: 0.133,
  F6: 0.1384,
  F7: 0.1424,
  F8: 0.145,
  F9: 0.1484,
  G0: 0.2242,
  G1: 0.2278,
  G2: 0.239,
  G3: 0.2306,
  G4: 0.2204,
  G5: 0.2202,
  G6: 0.2234,
  G7: 0.228,
  G8: 0.2032,
  G9: 0.2004,
  K0: 0.179,
  K1: 0.1404,
  K2: 0.1252,
  K3: 0.1046,
  K4: 0.094,
  K5: 0.0794,
  K6: 0.073,
  K7: 0.0634,
  K8: 0.0554,
  K9: 0.0522,
  M0: 0,
  M1: 0,
  M2: 0,
  M3: 0,
  M4: 0,
  M5: 0,
  M6: 0,
  M7: 0,
  M8: 0,
  M9: 0,
}
